import { Fragment } from 'react';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useRef } from 'react';

function MarketTable({ config, rows, filterBy, single, isFilter, date, onFilter, theme }) {
    const tableRef = useRef(null);

    const tableHeader = config.map((column) => {
        if (column.header) {
            return <Fragment key={column.key}>{column.header()}</Fragment>;
        }

        return <th className='text-center' key={column.key}>{column.value}</th>;
    });


    const handleClick = (e) => {
        const selecetedRow = document.querySelector('tr.selected')
        selecetedRow && selecetedRow.classList.remove('selected')
        e.target.parentNode.classList.add('selected')
    }


    const tableRows = rows.map((row, index) => {
        return <tr key={index} className='text-center' onClick={handleClick}>
            {
                config.map((column) => {

                    return <td key={column.value} className='px-0 py-2'>
                        <span
                            dir={column.direction && column.direction}
                            className={`d-inline-flex px-2 py-1 fw-semibold bg-opacity-10 ${column.className && column.className(row, filterBy)}`}>
                            {column.renderer(row, filterBy)}
                        </span>
                    </td>
                })
            }
        </tr>

    })

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: 'market',
        sheet: 'signal'
    })

    const btnClass = isFilter ? 'btn-primary text-white' : 'btn-light text-dark'

    let renderedFilter;
    if (filterBy === 'stock_rights') {
        renderedFilter = <h3>سهام و حق تقدم</h3>
    } else if (filterBy === 'stock_rights_fund') {
        renderedFilter = <h3>سهام و حق تقدم و صندوق سهامی</h3>
    } else if (filterBy === 'fund_fixed') {
        renderedFilter = <h3>صندوق در آمد ثابت</h3>
    } else {
        renderedFilter = <h3>صندوق طلا</h3>
    }

    return (
        <>
            <div className="d-flex justify-content-between align-items-center">
                <button onClick={onDownload} className='btn bg-success text-white mb-2 p-3'> خروجی اکسل </button>
                {onFilter && <button onClick={onFilter} className={`btn ${btnClass} mb-2 p-3`}>فیلتر</button>}
                {renderedFilter}
                {date && <h2>{date}</h2>}
            </div>
            {/* <div className='table-responsive'> */}

            <div className='w-100 mw-100 d-flex'>
                <table className={`table ${theme} table-rounded w-100 mw-100`} ref={tableRef}>
                    <thead>
                        <tr className="fw-semibold fs-6 border-bottom-2 mb-5 border-gray-200">
                            {tableHeader}
                        </tr>
                    </thead>

                    <tbody>
                        {tableRows}
                    </tbody>
                </table>
            </div>
            {/* </div> */}
        </>
    )
}

export default MarketTable